/**
 *
 * Diamond api table in use at
 * https://www.apresjewelry.com/blogs/news/lab-created-white-diamonds
 *
 */

(function($) {
  $(document).ready(function() {
    var $diamondTable = $("#diamond-table-api");
    if ($diamondTable.length > 0) {
      var DIAMONDS_API = "apres-diamond-api2";
      var DIAMONDS_API_STAMP_KEY = "apres-diamond-api-stamp2";
      var DIAMONDS_URL = "https://wondercraft.co/work/apres-jewerly/diamond-api.php?endpoint=api/v2/products";

      var filters = {};
      var order = ["carat", "desc"];
      var entries = [];

      var shapesWithImage = [
        {
          name: "Brilliant Round",
          image: "https://cdn.shopify.com/s/files/1/2496/1294/files/unnamed_2_small.png"
        },
        {
          name: "Emerald",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/emerald_2x_08cdb131-64c0-438d-822a-4978d969b0c6_small.png"
        },
        {
          name: "Oval",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/oval_2x_05522732-22bd-4106-9512-a78667901488_small.png"
        },
        {
          name: "Princes",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/princess_2x_d4723101-8a52-4507-94a8-7456504989af_small.png"
        },
        {
          name: "Asscher",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/asscher_2x_42c8ef1b-aa1e-46bf-9711-1a7daf486af9_small.png"
        },
        {
          name: "Cushion",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/cushion_2x_aa722592-b0de-42e3-8525-7d478a07f58e_small.png"
        },
        {
          name: "Rose",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/RoseFront101016_a85ac210-de61-41f4-8722-d0194d2ae6eb_small.png"
        },
        {
          name: "Radiant",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/radiant_2x_c3e96cf4-472c-4f78-b749-a0b48fc311ae_small.png"
        },
        {
          name: "Pear",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/pear_2x_e438d862-87cb-420d-841c-f232cf449b21_small.png"
        },
        {
          name: "Marquise",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/Marquise_Top_60x60_66530fab-4a83-4c34-ab5b-01457b9a8a81_small.png"
        },
        {
          name: "Oval Rose",
          image: "https://cdn.shopify.com/s/files/1/2496/1294/files/DFOvalRoseBottom60_small.png"
        },
        {
          name: "Capri",
          image:
            "https://cdn.shopify.com/s/files/1/2496/1294/files/Capri-Top_60x60_05f1fbe7-360a-4c7f-9dd4-a537f2d58094_small.png"
        },
        {
          name: "Aquila",
          image: "https://cdn.shopify.com/s/files/1/2496/1294/files/aquila-top-lg_small.png"
        },
        {
          name: "Trilliant",
          image: "https://cdn.shopify.com/s/files/1/2496/1294/files/DragonTrillionTop60_small.png"
        },
        {
          name: "Semi Rough",
          image: "https://cdn.shopify.com/s/files/1/2496/1294/files/semi-front_small.png"
        }
      ];

      var fetchData = function() {
        var dfd = $.Deferred();
        $.ajax(DIAMONDS_URL).then(function(res) {
          localStorage.setItem(DIAMONDS_API, JSON.stringify(res));
          localStorage.setItem(DIAMONDS_API_STAMP_KEY, new Date().getTime());
          dfd.resolve(res);
        });
        return dfd.promise();
      };
      var getData = function() {
        var dfd = $.Deferred();
        var timeStamp = window.localStorage.getItem(DIAMONDS_API_STAMP_KEY);
        var miliday = 1000 * 60 * 60 * 5;
        if (new Date().getTime() - timeStamp > miliday) {
          return fetchData();
        } else {
          var items = window.localStorage.getItem(DIAMONDS_API);
          if (items) {
            dfd.resolve(JSON.parse(items));
          } else {
            return fetchData();
          }
        }
        return dfd.promise();
      };
      var toCurrency = function(_num) {
        var num = typeof _num === "string" ? parseFloat(_num) : _num;
        return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"); // 12,345.67
      };

      var columnHeadTmpl = function(label, value) {
        var str = "<td class='right can-order ";
        str += order[0] === value ? "active " + order[1] : "";
        str += "' data-column='" + value + "'>" + label + "</td>";
        return str;
      };
      var tableTmpl = function() {
        var tableStr = "<table class='diamond-table'>";
        tableStr += "<thead><tr><td width='19%'>Shape</td>";
        tableStr += columnHeadTmpl("Carat", "carat");
        tableStr += columnHeadTmpl("Color", "color");
        tableStr += columnHeadTmpl("Clarity", "clarity");
        tableStr += columnHeadTmpl("Cut", "cut_grade");
        tableStr += columnHeadTmpl("Price", "unit_price_msrp_usd");
        tableStr += "<tbody></tbody></table>";
        return tableStr;
      };

      var trTmpl = function(entry) {
        var str = "<tr>";
        str += "<td>" + entry.shape + "</td>";
        str += "<td class='right active'>" + parseFloat(entry.carat).toFixed(2) + "</td>";
        str += "<td class='right'>" + entry.color + "</td>";
        str += "<td class='right'>" + entry.clarity + "</td>";
        str += "<td class='right'>" + entry.cut_grade + "</td>";
        str += "<td class='right'>$" + toCurrency(entry.unit_price_msrp_usd) + "</td>";
        str += "</tr>";
        return str;
      };

      var selectTmpl = function(options, label, name) {
        var filtersStr = "<div class='selector-wrapper'>";
        filtersStr += "<label>" + label + "</label>";
        filtersStr += "<select class='styled' name='" + name + "'>";
        filtersStr += "<option value=''>None</option>";
        options.forEach(function(option) {
          filtersStr += "<option value='" + option + "'>" + option + "</option>";
        });
        filtersStr += "</select></div>";
        return filtersStr;
      };

      var shapeImageTmpl = function(shape) {
        var str = "<div class='shape-image' data-name='" + shape.name + "'>";
        str += "<img src='" + shape.image + "' width='30' />";
        str += "<span>" + shape.name + "</span>";
        str += "</div>";
        return str;
      };

      var sliderTmpl = function(label, name, classname, _wrapperClass) {
        var wrapperClass = _wrapperClass || ""
        var str = "<div class='selector-wrapper selector-range "+wrapperClass+"'>";
        str += "<label>" + label + "</label>";
        str += "<input type='text' class='" + classname + "' name='" + name + "' />";
        str += "</div>";
        return str;
      };

      var renderFilters = function() {
        var $filtersWrapper = $diamondTable.find(".filtersWrapper");

        $filtersWrapper.append("<div class='shapes-images'>" + shapesWithImage.map(shapeImageTmpl).join("") + "</div>");
        $filtersWrapper.find(".shape-image").on("click", function() {
          var $this = $(this);
          filters.shape = $this.data("name");
          $this.addClass("active");
          $this.siblings().removeClass("active");
          renderTable();
        });

        /**
         * CARATS
         */
        $filtersWrapper.append(sliderTmpl("Carats", "carats", "range-slider-carats"));
        var weights = _(entries)
          .map(function(i) {
            return i.carat;
          })
          .uniq();
        var maxWeight = weights.max();
        var minWeight = weights.min();
        $(".range-slider-carats").ionRangeSlider({
          type: "double",
          grid: true,
          min: minWeight,
          max: maxWeight,
          from: minWeight,
          to: maxWeight,
          step: 0.01,
          onFinish: function(data) {
            filters.carat = { from: data.from, to: data.to };
            renderTable();
          }
        });
        /**
         * PRICE
         */
        $filtersWrapper.append(sliderTmpl("Price", "price", "range-slider-price"));
        var prices = _(entries)
          .map(function(i) {
            return parseFloat(i.unit_price_msrp_usd);
          })
          .uniq();
        var maxPrice = prices.max() + 20;
        var minPrice = prices.min() - 20;
        $(".range-slider-price").ionRangeSlider({
          type: "double",
          grid: true,
          min: minPrice,
          max: maxPrice,
          from: minPrice,
          to: maxPrice,
          prefix: "$",
          prettify_separator: ".",
          onFinish: function(data) {
            filters.unit_price_msrp_usd = { from: data.from, to: data.to };
            renderTable();
          }
        });
        /**
         * COLORS
         */

        $filtersWrapper.append(sliderTmpl("Color", "color", "range-slider-color", "half"));
        var colorValues = ["M", "L", "K", "J", "I", "H", "G", "F", "E", "D"];
        $(".range-slider-color").ionRangeSlider({
          type: "double",
          grid: true,
          from: 0,
          to: colorValues.length,
          values: colorValues,
          onFinish: function(data) {
            filters.color = colorValues.slice(data.from, data.to + 1);
            renderTable();
          }
        });

        /**
         * CLARITY
         */

        $filtersWrapper.append(sliderTmpl("Clarity", "clarity", "range-slider-clarity", "half"));
        var clarityValues = ["SI2", "SI1", "VS2", "VS1", "VVS2", "VVS1", "IF", "FL"];
        $(".range-slider-clarity").ionRangeSlider({
          type: "double",
          grid: true,
          from: 0,
          to: clarityValues.length,
          values: clarityValues,
          onFinish: function(data) {
            filters.clarity = clarityValues.slice(data.from, data.to + 1);
            renderTable();
          }
        });
        // var clarities = _(entries)
        //   .map("clarity")
        //   .uniq()
        //   .compact()
        //   .value();
        // console.log(clarities);
        // $filtersWrapper.append(selectTmpl(clarities, "Clarity", "clarity"));

        // $filtersWrapper
        //   .find("select.styled")
        //   .customSelect()
        //   .on("change", function(e) {
        //     filters[e.target.name] = e.target.value;
        //     renderTable();
        //   });
      };
      var renderTable = function() {
        var $table = $(tableTmpl());
        var filteredEntries = _.orderBy(SEARCHJS.matchArray(entries, _.pickBy(filters)), order[0], order[1]);
        var entriesTrs = "";
        if (filteredEntries.length > 0) {
          entriesTrs = filteredEntries.map(trTmpl);
        } else {
          entriesTrs =
            "<tr><td colspan='8' style='text-align:center'>All diamonds of the selected kind have been sold. Larger diamonds and unique shapes are rare and often waitlisted.</td><tr>";
        }
        $table.find("tbody").append(entriesTrs);
        var $tableWrapper = $diamondTable.find(".tableWrapper");
        $tableWrapper.empty();
        $tableWrapper.append($table);
      };

      $(document).on("click", ".can-order", function() {
        var column = $(this).data("column");
        if (column === order[0]) {
          order[1] = order[1] === "desc" ? "asc" : "desc";
        } else {
          order = [column, "desc"];
        }
        renderTable();
      });

      //INIT
      $diamondTable.html("Loading Diamond data table...");

      getData().then(function(res) {
        // for (var key in res) {
        //   if (res.hasOwnProperty(key)) {
        //     if (res[key].shape) {
        //       entries.push(res[key]);
        //     }
        //   }
        // }
        window.entries = entries = res;

        $diamondTable.empty();
        $diamondTable.append("<div class='filtersWrapper'></div>");
        $diamondTable.append("<div class='tableWrapper'></div>");

        renderFilters();
        renderTable();
      });
    }
  });
})(window.jQuery);
